module.exports = __webpack_public_path__ + "media/images/single25-f90ae4df6f5f42cf9a70fe9d0a53db88.jpg";